import React from 'react';

const ParishesCard = () => {
    return (
        <div>
            <div className="parishesCard">
                <div className="container">
                    <h3 className="parishesCard__title">Церковные приходы, которым вы можете помочь</h3>
                    <div className="parishesCard__content">
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">Храм святого <br/>
                                благоверного князя <br/>
                                Александра Невского</h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">
                                Храм Воскресения <br/>
                                словущего <br/>
                                на Успенском вражке
                            </h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">
                                Святой Мученицы <br/>
                                Татианы Домовый Храм
                            </h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">
                                Новоспасский <br/>
                                Ставропигиальный <br/>
                                Мужской Монастырь
                            </h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">
                                Храм святого <br/>
                                благоверного князя <br/>
                                Александра Невского
                            </h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">
                                Храм Воскресения <br/>
                                словущего <br/>
                                на Успенском вражке
                            </h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">
                                Святой Мученицы <br/>
                                Татианы Домовый Храм
                            </h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                        <div className="parishesCard__card">
                            <h4 className="parishesCard__text">
                                Новоспасский <br/>
                                Ставропигиальный <br/>
                                Мужской Монастырь
                            </h4>
                            <button className="parishesCard__btn greenBtn">Подробнее</button>
                        </div>
                    </div>
                    <button className="parishesCard__button blackBtn">Показать еще
                        <span><svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M4.02189 5.54033L0.198002 1.84656C-0.0659942 1.59154 -0.0660046 1.17806 0.197994 0.923031C0.461993 0.668007 0.890028 0.668017 1.15402 0.923039L4.49983 4.1551L7.84597 0.922709C8.10997 0.667684 8.538 0.667695 8.802 0.922716C9.066 1.17774 9.066 1.59122 8.80201 1.84625L4.99346 5.52532C4.98845 5.53049 4.98314 5.53529 4.97792 5.54034C4.74693 5.76316 4.39016 5.79125 4.12792 5.62399C4.09042 5.60007 4.0549 5.57222 4.02189 5.54033Z" fill="#363A45"/>
</svg>
</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ParishesCard;